import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function AudienceSection() {
  const forWho = ['Parejas con hijos pequeños (0-6 años) que se sienten distantes.', 'Padres que aman a sus hijos pero extrañan desesperadamente a su amante.', 'Personas que sienten que el sexo se ha vuelto una "obligación" de la lista.', 'Parejas que quieren proteger su matrimonio antes de que el distanciamiento sea irreversible.'];
  const notForWho = ['Personas en relaciones abusivas o con infidelidades activas sin tratar.', 'Quienes buscan una solución mágica que no requiera 3 minutos de intención al día.', 'Parejas que no están dispuestas a soltar el teléfono 10 minutos antes de dormir.'];
  return <section className="px-6 py-10 bg-brand-light/5" data-id="element-21">
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-22">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="space-y-8" data-id="element-23">
          <h3 className="font-serif text-3xl text-brand-light border-b border-brand-light/10 pb-4" data-id="element-24">
            Esto <span className="text-green-400 italic" data-id="element-25">SÍ</span> es para ti
            si...
          </h3>
          <ul className="space-y-6" data-id="element-26">
            {forWho.map((item, i) => <li key={i} className="flex gap-4 items-start" data-id="element-27">
                <CheckCircle2 className="w-6 h-6 text-green-400 shrink-0 mt-0.5" data-id="element-28" />
                <span className="text-brand-light/80 font-light" data-id="element-29">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="space-y-8" data-id="element-30">
          <h3 className="font-serif text-3xl text-brand-light border-b border-brand-light/10 pb-4" data-id="element-31">
            Esto <span className="text-brand-accent italic" data-id="element-32">NO</span> es para ti
            si...
          </h3>
          <ul className="space-y-6" data-id="element-33">
            {notForWho.map((item, i) => <li key={i} className="flex gap-4 items-start" data-id="element-34">
                <XCircle className="w-6 h-6 text-brand-accent shrink-0 mt-0.5" data-id="element-35" />
                <span className="text-brand-light/80 font-light" data-id="element-36">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}